import type { AuthenticatedUserAttributes, Membership } from '../types/amplify';

export const getUserAttributes = async (): Promise<
  (AuthenticatedUserAttributes & Membership) | null
> => {
  try {
    const { attributes, signInUserSession } =
      await window.Amplify.default.Auth.currentAuthenticatedUser();
    const idToken = signInUserSession?.idToken?.jwtToken;
    const membershipExpiryDate =
      signInUserSession?.idToken?.payload['custom:membership_expiry_date'];
    const membershipIsActive = signInUserSession?.idToken?.payload['custom:membership_is_active'];

    return {
      ...attributes,
      idToken,
      membershipExpiryDate: membershipExpiryDate || null,
      membershipIsActive: membershipIsActive === 'true',
    };
  } catch (e) {
    return null;
  }
};
